import { render } from "./page-number.vue?vue&type=template&id=61771dcf&scoped=true&ts=true"
import script from "./page-number.vue?vue&type=script&setup=true&lang=ts"
export * from "./page-number.vue?vue&type=script&setup=true&lang=ts"

import "./page-number.vue?vue&type=style&index=0&id=61771dcf&scoped=true&lang=less"

import exportComponent from "/home/runner/work/smanga/smanga/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61771dcf"],['__file',"src/views/browse-view/components/page-number.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "61771dcf"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('61771dcf', __exports__)) {
    console.log('reload')
    api.reload('61771dcf', __exports__)
  }
  
  module.hot.accept("./page-number.vue?vue&type=template&id=61771dcf&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('61771dcf', render)
  })

}


export default __exports__